<template>
  <div>
    <div class="hd header">
      <div class="header_ld"  @click="historyback" v-show="showBack"></div>
      <div v-bind:class="[{'keepcenter': !showBack}, 'header_md']">{{titleName}}</div>
      <div class="header_rd">
        <a v-bind:class="[{'position_second': showRefresh}, 'hr_icon link_reload']" @click.prevent="refresh"><img src="/static/image/refresh.png" v-show="showRefresh"></a>
        <a class="hr_icon position_first" title="更多账户相关功能" v-show="showMore" @click.prevent="more"><img src="/static/image/icon_more.png"></a>
      </div>
    </div>
    <div class="js_dialog quitAudit" style="display: none;">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">取消审核</strong></div>
        <div class="weui-dialog__bd">终止当前审核吗？</div>
        <div class="weui-dialog__ft">
          <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="cancel">取消</a>
          <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="quit">确定</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    mounted: function () {
      this.$nextTick(function () {
      })
    },
    props: ['titleName', 'showRefresh', 'showBack', 'showBackTip', 'showMore'],
    methods: {
      historyback: function () {
        if (this.showBackTip) {
          window.$('.quitAudit').fadeIn(200)
          return
        }
        this.$router.back()
      },
      refresh: function () {
        this.$emit('refreshList')
      },
      quit: function () {
        this.$router.back()
      },
      cancel: function () {
        window.$('.quitAudit').fadeOut(200)
      },
      more: function () {
        this.$emit('showmoremenu')
      },
      mainMenuData: function () {
        this.$emit('mainMenuData')
      }
    }
  }
</script>
<style>
.keepcenter{margin-left: 20%}
.header{height: 44px; line-height: 44px; position: relative; background-color: #545454; color: #fff;}
.header .header_ld,
.header .header_rd{width: 20%; float: left; text-align: center;}
.header .header_ld:after{ content: " "; display: inline-block; -webkit-transform: rotate(225deg); transform: rotate(225deg); height: 10px; width: 10px; border-width: 4px 4px 0 0; border-color: #fff; border-style: solid; position: relative; top: -2px; top: -1px; margin-left: .3em;}
.header .header_md{width: 60%; float: left; text-align: center;}
.header .header_rd a{display: block; width: 100%; height: 44px;}
.header .header_rd img{width: 32px; height: 32px; position: relative; top: 6px;} 
.header .header_rd a.hr_icon{width: 12%; position: absolute;}
.position_first{right: 3%}
.position_second{right: 15%}
</style>


// WEBPACK FOOTER //
// head.vue?05789e36